module.exports = __webpack_public_path__ + "static/media/new-form-logo.22251d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/new-form-logo.png
// module id = 691
// module chunks = 0